import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/Footer";
import { StatsDashboard } from "@/components/homepage/StatsDashboard";
import { FeatureGrid } from "@/components/homepage/FeatureGrid";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1 h-full overflow-y-auto bg-background">
        <div className="flex h-full flex-col gap-8 md:gap-12 py-8 md:py-12">
          <StatsDashboard />
          <FeatureGrid />
        </div>
      </main>
      <Footer />
    </div>
  );
}

